import { produce } from "immer";

import { normalizeBase } from "@ds/model/helpers";

import { isCampaignQueryOutput, isCampaignArray } from "./model";

const normalizer = (entity: Campaign): Campaign => normalizeBase({ description: undefined, ...entity });

export const normalize = ((
  entityOrEntities: Campaign | Campaign[] | QueryOutput<Campaign>,
): Campaign | Campaign[] | QueryOutput<Campaign> => {
  if (isCampaignQueryOutput(entityOrEntities)) {
    return produce(entityOrEntities, draft => {
      draft.items = entityOrEntities.items.map(normalizer);
    });
  }

  return isCampaignArray(entityOrEntities) ? entityOrEntities.map(normalizer) : normalizer(entityOrEntities);
}) as {
  (campaign: Campaign): Campaign;
  (campaigns: Campaign[]): Campaign[];
  (campaignsQueryOutput: QueryOutput<Campaign>): QueryOutput<Campaign>;
};
